import useEntity from "../../hooks/useTimberType";
import TimberTypeDetail from "../../components/timberType/TimberTypeDetail/TimberTypeDetail";
import TimberTypeScoped from "../../components/timberType/TimberTypeDetail/TimberTypeScoped";
import TimberTypeTabs from "../../components/timberType/TimberTypeDetail/TimberTypeTabs";
import { useGetTimberTypeQuery } from "../../apis/TimberType.api";
import { PrimaryTimberType } from "../../types/models/TimberType";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberTypeDetailPage = () => {

    useTitle(t`Details Timber Type`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { timberTypeId: id } = useParams();

    const { data, refetch } = useGetTimberTypeQuery(PrimaryTimberType.fromPath(id))
    const { deleteTimberType } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteTimberType(data, '..')
    }, [data, deleteTimberType])

    if (id === 'scoped') {
        return (<TimberTypeScoped/>)
    }

    return (
        <Box data-testid="TimberType-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <TimberTypeDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberTypes/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="TimberType-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/TimberTypes/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="TimberType-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <TimberTypeTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default TimberTypeDetailPage;
